import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { CurrentAgentService } from 'app/core/agent/current-agent.service';
import { from, map } from 'rxjs';

/**
 * Guard that checks if authenticated user has an agent profile.
 * If not, redirects to complete-profile page.
 *
 * Corre en `canActivateChild`, o sea en CADA navegacion dentro de /admin, por
 * lo que resolvia el agente contra la red una y otra vez y retrasaba la
 * apertura de cada pagina. CurrentAgentService cachea el perfil ya resuelto y
 * lo invalida cuando cambia la sesion, asi que a partir de la primera
 * navegacion esto no cuesta ningun viaje.
 */
export const AgentProfileGuard: CanActivateFn | CanActivateChildFn = () => {
    const router: Router = inject(Router);
    const currentAgent = inject(CurrentAgentService);

    return from(currentAgent.get()).pipe(
        map(({ agentId, userId }) => {
            // Sin sesion no es cosa de este guard: lo resuelve AuthGuard.
            if (!userId) return true;
            if (agentId) return true;
            return router.parseUrl('/auth/complete-profile');
        })
    );
};
